module.exports = __webpack_public_path__ + "static/img/PT.4379c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/PT.png
// module id = 1kHP
// module chunks = 1